import React from "react";
import { TextField, Button } from '@mui/material'
import withModal from '../../Modal'

const AddTeamModal = (props: any) => {

    return (
        <div className='modal' style={{ display: 'block', zIndex: 1200, position: 'fixed', top: '20%' }} role='dialog'>
            <div className='modal-dialog'>
                <div className='modal-content'>
                    <div className='modal-body'>
                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                                <TextField
                                    label='Name'
                                    name='teamName'
                                    fullWidth
                                    onChange={(e:any) => props.changeNewTeam(e)}
                                    value={props.newTeam.teamName}
                                 />
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                                <TextField 
                                    label='Beschreibung'
                                    name='teamDescription'
                                    fullWidth
                                    onChange={(e:any) => props.changeNewTeam(e)}
                                    value={props.newTeam.teamDescription}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='modal-footer'>
                                <Button 
                                    className='btn' 
                                    color='secondary'
                                    variant='contained'
                                    onClick={() => props.hide()}>
                                    Abbrechen
                                </Button>
                                <Button 
                                    className='btn' 
                                    color='primary'
                                    variant='contained'
                                    onClick={() => props.submitNewTeam()}>
                                    Hinzufügen
                                </Button>
                            </div>
                </div>
            </div>
        </div>
    )
}

export default withModal(AddTeamModal)